/* eslint-disable import/no-anonymous-default-export */
import { combineReducers } from 'redux-immutable';
import { connectRouter } from 'connected-react-router';
import appReducer from './app-reducer';
import productHistoryReducer from './product-history-reducer';
import trendingProductReducer from './trending-product-reducer';
import topDiscountReducer from './top-discount-reducer';
import bestSellingReducer from './best-selling-reducer';
import quickViewReducer from './quick-view-reducer';
import themeSettingReducer from './theme-setting-reducer';
import saveBarReducer from './save-bar-reducer';

export default history =>
  combineReducers({
    router: connectRouter(history),
    appReducer,
    productHistoryReducer,
    trendingProductReducer,
    themeSettingReducer,
    topDiscountReducer,
    bestSellingReducer,
    quickViewReducer,
    saveBarReducer
  });
